import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import HomePage from './components/HomePage';
// import StartPage from './components/StartPage';
import Privacy from './components/Privacy';

import { Box } from '@mui/material';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const MainRouter = () => {

  return (
    <React.Fragment>
      {/* <ScrollToTop /> */}
      <Routes>
        <Route path="*" element={<HomePage />}></Route>
        {/* <Route path="*" element={<Privacy />}></Route> */}
        {/* <Route path="*" element={<StartPage />}></Route> */}
      </Routes>

    </React.Fragment>
  );
};

export default MainRouter;
